import { useState } from 'react';
import PropertiesConstants from '../../constants/PropertiesConstants';

import type { Dispatch, SetStateAction } from 'react';

const getInitialFilterOptions = () => {
  return {
    options: PropertiesConstants.PROPERTIES_SUBNAV_FILTER_OPTIONS.reduce(
      (acc, subNav) => {
        acc[subNav.id] = { ...subNav };
        return acc;
      },
      {} as {
        [key: string]: (typeof PropertiesConstants.PROPERTIES_SUBNAV_FILTER_OPTIONS)[number];
      },
    ),
  };
};

export type FilterOptions = ReturnType<typeof getInitialFilterOptions>;

export const useFilterOptions = (): [FilterOptions, Dispatch<SetStateAction<FilterOptions>>] => {
  const [filterOptions, setFilterOptions] = useState(getInitialFilterOptions());
  return [filterOptions, setFilterOptions];
};
